<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1000px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text medium icon v-bind="attrs" v-on="on">
              <v-icon medium color="gray lighten-1"> mdi-upload </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-card-title>
                <span class="headline">Upload de Documento de Tranferência</span>
              </v-card-title>
            </v-col>
          </v-row>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <v-file-input
                    v-model="$v.form.document.$model"
                    accept="application/pdf"
                    label="Scan da Pagina de Assinatura do Comprovante*"
                    color="red lighten-1"
                    placeholder="Selecione um documento PDF"
                    :error-messages="errors.data.document"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialog = false"> Fechar </v-btn>
            <v-btn color="black" text @click="storeDocument()"> Salvar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TransferDocumentUpload',
  props: { movementId: Number },
  data: () => ({
    dialog: false,
    form: {
      document: [],
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
      },
      data: {
        document: [],
      },
    },
  }),
  validations: {
    form: {
      document: { required },
    },
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('movements', ['ActionStoreTransferDocument']),

    async storeDocument() {
      this.ActionSetLoading(true)
      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          treated_form.append('document', this.form.document)

          let movement_obj = {
            id: this.movementId,
            form_data: treated_form,
          }

          await this.ActionStoreTransferDocument(movement_obj)
          this.$swal({
            icon: 'success',
            title: 'Upload Concluido',
            text: 'Upload do documento concluido com sucesso',
          })
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }
      this.ActionSetLoading(false)
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors
      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)
      this.errors.data[key] = errors
    },
  },
}
</script>